import { useState, useEffect } from 'react';

const CountUp = ({ end, duration = 2000, suffix = '' }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let startTime = null;
        const start = 0;

        const animate = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const progress = currentTime - startTime;
            const percentage = Math.min(progress / duration, 1);

            // Easing function: easeOutExpo
            const ease = (t) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t);

            const currentCount = Math.floor(start + (end - start) * ease(percentage));
            setCount(currentCount);

            if (progress < duration) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }, [end, duration]);

    return <span>{count}{suffix}</span>;
};

export default CountUp;
